import { Component, Input } from 'angular-ts-decorators';

/**
 * Component that displays an image
 * Additionally can become an image with a link
 * If editable is true, a link is created with link of `href`
 *
 * # Bindings
 * @param {boolean} editable allows href on the image
 * @param {string} link contains the href link of the image
 * @param {string} source source of the image
 *
 * # Example
 * <pre>
 *   <product-photo>
 *     editable="true"
 *     link="'http://test.nl'"
 *     source="'http://test.nl/image.jpg'"
 *   </product-photo>
 * </pre>
 */
// TODO change name. Product agnostic component
@Component({
  selector: 'productPhoto',
  template: require('./product-photo.html').default,
})
export class ProductPhotoComponent {
  @Input() editable: boolean;
  @Input() source: string;
  @Input('@') link: string;

  constructor() {
    'ngInject';
  }

  getLink() {
    if (this.editable) {
      return this.link;
    }
  }
}
